import React, { useEffect, useState } from 'react';
import { ref, query, orderByChild, equalTo, onValue } from 'firebase/database';
import { database } from '../firebaseConfig';
import { useAuth } from '../context/AuthContext';
import { canUseCrm } from '../config/crm';
import { crmIdentity } from './CrmGate';

// Upcoming CRM appointments for the signed-in agent (crm/appointments, agentUid = me), shown on the
// Calendar tab. Each has an "Add to Google Calendar" link until two-way sync is connected.
const gcalLink = (a) => {
  const s = new Date(a.startAt); const e = new Date(s.getTime() + 60 * 60 * 1000);
  const f = (d) => d.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
  const details = [a.type, a.zoomLink ? `Zoom: ${a.zoomLink}` : '', a.notes].filter(Boolean).join('\n');
  return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(`Appointment: ${a.contactName} (${a.type})`)}&dates=${f(s)}/${f(e)}&details=${encodeURIComponent(details)}&location=${encodeURIComponent(a.location || a.zoomLink || '')}`;
};

export default function MyAppointments({ cardStyle, h2Style }) {
  const auth = useAuth();
  const { user, userRole } = auth;
  const [items, setItems] = useState([]);
  const allowed = canUseCrm(userRole, crmIdentity(auth).uid, crmIdentity(auth).email);
  useEffect(() => {
    if (!user?.uid || !allowed) return undefined;
    return onValue(query(ref(database, 'crm/appointments'), orderByChild('agentUid'), equalTo(user.uid)), (snap) => {
      const v = snap.val() || {};
      setItems(Object.entries(v).map(([id, a]) => ({ id, ...a })).filter((a) => a.status !== 'canceled' && new Date(a.startAt) > new Date(Date.now() - 3600 * 1000)).sort((a, b) => a.startAt.localeCompare(b.startAt)));
    }, () => setItems([]));
  }, [user, allowed]);
  if (!allowed) return null;
  return (
    <div style={cardStyle}>
      <h2 style={h2Style}>My Appointments</h2>
      {items.length === 0 ? <p style={{ color: '#7f7f7f', fontSize: 14 }}>No upcoming appointments. Set one from a call with the "Appointment set" result.</p> : items.map((a) => (
        <div key={a.id} style={{ padding: '10px 0', borderBottom: '1px solid #eee', display: 'flex', flexWrap: 'wrap', gap: 8, justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <strong>{new Date(a.startAt).toLocaleString([], { weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })}</strong> · {a.contactName} · {a.type}
            {a.location && <div style={{ fontSize: 13, color: '#666' }}>{a.location}</div>}
            {a.zoomLink && <div style={{ fontSize: 13 }}><a href={a.zoomLink} target="_blank" rel="noreferrer">Zoom link</a></div>}
          </div>
          <div style={{ display: 'flex', gap: 10, fontSize: 13 }}>
            <a href={`/leads/contacts?id=${a.contactId}`}>Open contact</a>
            <a href={gcalLink(a)} target="_blank" rel="noreferrer">Add to Google Calendar</a>
          </div>
        </div>
      ))}
    </div>
  );
}
